export default "__VITE_ASSET__CtlK3k3$__"